/**
 * Плашка «позначено N документів · сума: X грн · зняти позначки» над таблицею —
 * підсумок рядків, позначених галочками (ч.1033 звіт «Розрахунки за документами»;
 * ч.1184 — списки банку, запит власника). Нічого не позначено — нічого не малює.
 */
import { docsWord } from '@/shared/utils/selectionSum';

interface Props {
  count: number;
  /** Сума позначених (грн). */
  sum: number;
  /** Підпис суми: «сума» / «залишок боргу». */
  label?: string;
  onClear: () => void;
}

const fmt = (n: number) =>
  n.toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function SelectionSum({ count, sum, label = 'сума', onClear }: Props) {
  if (count === 0) return null;
  return (
    <span className="sel-sum" data-testid="sel-sum">
      <span>позначено {count} {docsWord(count)}</span>
      <span>·</span>
      {/* Сума не рветься посеред числа на великому шрифті. */}
      <span>{label}: <strong style={{ whiteSpace: 'nowrap' }}>{fmt(sum)} грн</strong></span>
      <span>·</span>
      <button type="button" className="btn-link" onClick={onClear}>
        зняти позначки
      </button>
    </span>
  );
}
